module.exports = __webpack_public_path__ + "img/hk_room_floorplan_04.2cc4ec13.png";